import { actionTypes } from '../actions/afiliados.action';
const initialState = {
    afiliados: {
        data: []
    },
    chart: {
        period: {
            period_chart: [],
            today: {}, 
            campaigns: [],
            stats: {}
        },
        hour: {
            best_hour: {},
            best_window: {},
            hourly_chart: [],
            campaigns: [],
        },
        afiliado: {}
    },
    afiliado: {},
    error: {},
    success: false
}

const AfiliadosReducer = (state = initialState, { type, payload, isLoadMore }) => {
    switch (type) {

    case actionTypes.INDEX:
        if(isLoadMore) {
            payload.afiliados.data = state.afiliados.data.concat(payload.afiliados.data)
        }

        return { ...state, ...payload }

    case actionTypes.CHART:
        return {
            ...state,
            chart: {
                afiliado: payload?.afiliado,
                period: {
                    ...state.chart.period,
                    ...payload.period
                },
                hour: {
                    ...state.chart.hour,
                    ...payload.hour
                }
            }
        }

    case actionTypes.UPDATE:
        let index = state.afiliados.data.findIndex(item => item.id === payload.id)
        state.afiliados.data[index] = payload

        return {
            ...state,
            afiliados: {
                ...state.afiliados,
                data: [
                    ...[(index < 0) && payload],
                    ...state.afiliados.data
                ]
            }
        }

    case actionTypes.CHANGE_AFILIADO:
        return {
            ...state,
            afiliado: {
                ...state.afiliado,
                ...payload
            }
        }

    case actionTypes.DESTROY:
        return {
            ...state,
            afiliados: {
                ...state.afiliados,
                data: state.afiliados.data.filter(item => item.id !== payload)
            }

        }

    case actionTypes.CHANGE:
        return {
            ...state,
            afiliado: (payload === 'clear') ? {} : {
                ...state.afiliado,
                ...payload
            }
        }

    case actionTypes.SUCCESS:
        return {
            ...state,
            success: payload
        }

    case actionTypes.ERROR:
        return {
            ...state,
            error: payload
        }

    default:
        return state
    }
}

export default AfiliadosReducer